// This module may contain traces of compiler construction.

import { Utils } from '../core/utils';
import { FontDescription, Text, TextChunk } from './text.model';

import { emitTextChunks } from './text.view.div.codegen';
import { makeTokenWalker, stripEmptyTokens, tokenize,
       } from './text.view.div.lexer';
import { parse } from './text.view.div.parser';
import { applyAlignmentToNode, applyBearing, applyChunksToNode,
         applyFontFamily, applyFontSizeToNode, applyLeading, applyTextColor
       } from './text.view.div.renderer';
import { makeSelectionLookup } from './text.view.div.selection';
import { IEH_flattenNodeHierarchy, insertSiblingLinks, markDepth,
         markIgnoredLinebreaks, mergeAdjacentMarkers, removeContentlessWords,
         resolveProxyNodes
       } from './text.view.div.transformations';

export function applyModel(
  element: HTMLDivElement, model: Text, font: FontDescription): HTMLDivElement
{
  applyChunksToNode(element, model.text);
  applyFontSizeToNode(element, model.fontSize);
  applyAlignmentToNode(
    element,
    model.horizontalAlignment,
    model.verticalAlignment,
    model.fontSize,
    model.leading,
    model.availableArea
  );
  applyFontFamily(element, model.fontName);
  applyLeading(element, model.leading, model.fontSize);
  applyTextColor(element, model.color);
  applyBearing(element, model, font, model.availableArea);

  return element;
}

export function extractTextChunks(element: HTMLDivElement): Array<TextChunk>
{
  const tokens = stripEmptyTokens(tokenize(element, makeSelectionLookup()));
  const ast = parse(makeTokenWalker(tokens));

  resolveProxyNodes(ast);
  removeContentlessWords(ast);
  markDepth(ast);
  IEH_flattenNodeHierarchy(ast);
  markDepth(ast);
  insertSiblingLinks(ast);
  mergeAdjacentMarkers(ast);
  insertSiblingLinks(ast);
  markIgnoredLinebreaks(ast);

  return Utils.flattenArray((ast.children || []).map(emitTextChunks));
}



// WEBPACK FOOTER //
// ./src/app/text/text.view.div.ts